import axios, { AxiosResponse } from 'axios'



export async function uploadAvatar(
    token: string,
    tbUid: string,
    avatarFile: any
): Promise<any> {

    const avatarMetadata = {
        contentType: "image/png",
        title: tbUid
    };

    const initiateResult: any = await axios.post(`${process.env.NEXT_PUBLIC_IDENTITY}/identity/avatar`,
        avatarMetadata, {
        headers: {
            Authorization: token
        }
    }
    );

    console.log(initiateResult.data.s3PutObjectUrl)
    let url = initiateResult.data.s3PutObjectUrl;
    axios.put(url, avatarFile, { headers: { 'Content-Type': avatarMetadata.contentType } });
}

